import * as React from "react";
import { cn } from "@/lib/utils";
import { useIsMobile } from "@/hooks/use-mobile";

interface MobileFormProps extends React.FormHTMLAttributes<HTMLFormElement> {
  children: React.ReactNode;
}

interface MobileFormFieldProps {
  children: React.ReactNode;
  className?: string;
}

interface MobileFormActionsProps {
  children: React.ReactNode;
  className?: string;
}

const MobileForm = React.forwardRef<HTMLFormElement, MobileFormProps>(
  ({ className, children, ...props }, ref) => {
    const isMobile = useIsMobile();

    return (
      <form
        ref={ref}
        className={cn("space-y-6", isMobile && "space-y-4", className)}
        {...props}
      >
        {children}
      </form>
    );
  },
);
MobileForm.displayName = "MobileForm";

const MobileFormField = React.forwardRef<HTMLDivElement, MobileFormFieldProps>(
  ({ className, children, ...props }, ref) => {
    const isMobile = useIsMobile();

    return (
      <div
        ref={ref}
        className={cn("space-y-2", isMobile && "space-y-3", className)}
        {...props}
      >
        {children}
      </div>
    );
  },
);
MobileFormField.displayName = "MobileFormField";

const MobileFormActions = React.forwardRef<
  HTMLDivElement,
  MobileFormActionsProps
>(({ className, children, ...props }, ref) => {
  const isMobile = useIsMobile();

  return (
    <div
      ref={ref}
      className={cn("flex gap-3 pt-4", isMobile && "flex-col gap-4", className)}
      {...props}
    >
      {children}
    </div>
  );
});
MobileFormActions.displayName = "MobileFormActions";

export { MobileForm, MobileFormField, MobileFormActions };
